module.exports = __webpack_public_path__ + "static/img/search.237c9d47.svg";